import {playCircleSvg as Icon__small__playCircleSvg} from '../Icon__small/Icon__small--playCircle.js'

export var playCircle = {
  name: 'playCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__playCircleSvg,
};
